import { MonthPickerProps } from '../monthPicker/monthPickerTypes';
import { MultiSelectSearchProps } from '../multiSelectSearch/multiSelectSearchTypes';
import { SelectProps } from '../select/selectTypes';
import { UserSearchProps } from '../userSearch/userSearchTypes';
import { MultiTagsSelectProps } from '../entityAndActionsFilter/multiTagsSelect';
import { SelectTimeFrameProps } from '../selectTimeFrame/selectTimeFrameTypes';

export interface FiltersWrapperProps {
    filters: (FilterTypeProps & FilterProps)[];
    onApplyCallback: Function;
    onCancelCallback: Function;
    width?: number;
    isAbsolute?: boolean;
    initialState?: object;
    filtersWrapperCX?: string;
    actionsWrapperCX?: string;
    onFilterChangeCallback?: Function;
    initExpandedFilters?: boolean;
    filtersWrapperStyle?: object;
}

export type FilterTypeProps =
    | {
          selectFilter: SelectProps;
      }
    | {
          multiSelectFilter: MultiSelectSearchProps;
      }
    | {
          monthPickerFilter: MonthPickerProps;
      }
    | {
          userSearchFilter: UserSearchProps;
      }
    | {
          multiTagsSelectFilter: MultiTagsSelectProps;
      }
    | {
          timeFrameFilter: SelectTimeFrameProps;
      };

export type FilterProps = {
    key: string;
    type: FilterTypes;
    title: string;
    info?: string;
    expandedHeight?: number;
};

export enum FilterTypes {
    select = 'select',
    multiSelect = 'multiSelect',
    monthPicker = 'monthPicker',
    userSearch = 'userSearch',
    multiTagsSelect = 'multiTagsSelect',
    timeFrame = 'timeFrame'
}
